export default (callback, wait) => {
    var timer = null;
    return function(){
        if(timer !== null){
            clearTimeout(timer);
        }
        timer = setTimeout(callback,wait);
    }
}


// WEBPACK FOOTER //
// ./src/assets/js/debounce.js